/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const analyticAutoOrderService = {
  getList: (params: any) => request.get('/analytic/auto-order', { params })
};

export default analyticAutoOrderService;
